import { CalendarOutlined } from "@ant-design/icons";

export const BookingDetails = (props) => {
  const { selectedBooking } = props;
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        <CalendarOutlined style={{ fontSize: "20px", color: "#1890ff" }} />
        <h3 style={{ margin: 0, color: "#333" }}>Booking Details</h3>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "10px",
        }}
      >
        <p style={{ margin: 0 }}>
          <strong>Booking ID:</strong>{" "}
          <span style={{ color: "#1890ff", fontWeight: "bold" }}>
            {selectedBooking.bookingId || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>User ID:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.userid || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Check-In Date:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.fromdate || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Check-Out Date:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.todate || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Total Days:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.totaldays || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Status:</strong>
          <span
            style={{
              color:
                selectedBooking.status === "Booked"
                  ? "#52c41a"
                  : selectedBooking.status === "Cancelled"
                  ? "#ff4d4f"
                  : "#faad14",
              fontWeight: "bold",
            }}
          >
            {selectedBooking.status || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Booking Source:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.bookingSource || "N/A"}
          </span>
        </p>
      </div>
    </div>
  );
};
